import { render, staticRenderFns } from "./ProductSalesPromotionAnalyse.vue?vue&type=template&id=67a71bd8&scoped=true&"
import script from "./ProductSalesPromotionAnalyse.vue?vue&type=script&lang=js&"
export * from "./ProductSalesPromotionAnalyse.vue?vue&type=script&lang=js&"
import style0 from "./ProductSalesPromotionAnalyse.vue?vue&type=style&index=0&id=67a71bd8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67a71bd8",
  null
  
)

export default component.exports